function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.9891 1.5C6.64429 1.5 1.5 6.6483 1.5 13C1.5 19.3517 6.64429 24.5 12.9891 24.5C19.334 24.5 24.4783 19.3517 24.4783 13C24.4783 6.6483 19.334 1.5 12.9891 1.5ZM0.5 13C0.5 6.09687 6.09115 0.5 12.9891 0.5C19.8871 0.5 25.4783 6.09687 25.4783 13C25.4783 19.9031 19.8871 25.5 12.9891 25.5C6.09115 25.5 0.5 19.9031 0.5 13Z",
  fill: "#697B8B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5858 7H14.7875C13.9925 7 13.2302 7.31607 12.6681 7.87868C12.106 8.44129 11.7902 9.20435 11.7902 10V11.8H9.99182V14.2H11.7902V19H14.188V14.2H15.9864L16.5858 11.8H14.188V10C14.188 9.84087 14.2512 9.68826 14.3636 9.57574C14.476 9.46321 14.6285 9.4 14.7875 9.4H16.5858V7Z",
  fill: "#697B8B"
});

var SvgFb = function SvgFb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fb.932d11f1.svg";
export { ForwardRef as ReactComponent };